import styled from 'styled-components'

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const Text = styled.div`
  ${({ theme }) => `
    color: ${theme.color.white};
    font-weight: ${theme.fontWeight.bold};
  `}
`

export const ImageContainer = styled.div`
  display: flex;
  align-items: center;
  padding-top: 8px;

  > svg {
    margin: 0 10px;
  }
`
